import { Injectable } from '@angular/core';
import { GlobalApiService } from '../global-api.service';
import { Observable } from 'rxjs';
import * as socketIO from 'socket.io-client';
import { Event } from 'src/app/models/side-nav.data';

@Injectable()
export class SocketService {
  private url = this.globalService.getSocketUrl();
  private socket: any;

  constructor(
    private globalService: GlobalApiService) {
  }
  initializeSocketIO() {
    this.socket = socketIO(this.url, { transports: ['websocket'] });
  }
  public sendMessage(message): void {
    this.socket.emit('new-message', message);
  }

  public notificationConnection(message): void {
    this.socket.emit('notificationConnection', message);
  }

  public checkPopUpStatus(branchId): void {
    this.socket.emit('checkPopUpStatus', branchId);
  }

  getMessages(): Observable<any> {
    return new Observable<any>(observer => {
      this.socket.on('reply', (data: any) =>
        observer.next(data));
    });
  }

  getAdds(): Observable<any> {
    return new Observable<any>(observer => {
      this.socket.on('new-add', (data: any) => {
        // console.log("NEW AD");
        observer.next(data)
      });
    });
  }

  getSocialPopUp(): Observable<any> {
    return new Observable<any>(observer => {
      this.socket.on('socialPopup', (data: any) => {
        // console.log("NEW AD");
        observer.next(data)
      });
    });
  }

  getNotifications(): Observable<any> {
    return new Observable<any>(observer => {
      this.socket.on('notification', (data: any) =>
        observer.next(data));
    });
  }

  getFeedback(): Observable<any> {
    return new Observable<any>(observer => {
      this.socket.on('gymFeedback', (data: any) =>
        observer.next(data));

    });
  }
  getBiometricSuggestion(): Observable<any> {
    return new Observable<any>(observer => {
      this.socket.on('biometricSuggestion', (data: any) =>
        observer.next(data));
    });
  }

  onsucess(): Observable<any> {
    return new Observable<any>(observer => {
      this.socket.on('success', (data: any) =>
        observer.next(data));

    });
  }

  getQrCode(): Observable<any> {
    return new Observable<any>(observer => {
      this.socket.on('wa-qrcode', (data: any) =>
        observer.next(data));
    });
  }
  sessionlogged(): Observable<any> {
    return new Observable<any>(observer => {
      this.socket.on('session-logged', (data: any) =>
        observer.next(data));
    });
  }
  sessionError(): Observable<any> {
    return new Observable<any>(observer => {
      this.socket.on('session-error', (data: any) =>
        observer.next(data));
    });
  }

  reLoginWhats(): Observable<any> {
    return new Observable<any>(observer => {
      this.socket.on('wa-login', (data: any) =>
        observer.next(data));
    });
  }

  public onEvent(event: Event): Observable<any> {
    return new Observable<Event>(observer => {
      this.socket.on(event, () => observer.next());
    });
  }

  // --- Emitters ---
  requestScreenShare(branchId: string, from: string) {
    this.socket.emit('screen-share-request', { branchId, from });
  }

  sendOffer(target: string, from: string, room: string, offer: RTCSessionDescriptionInit) {
    this.socket.emit('webrtc-offer', { to: target, from, room, offer });
  }

  sendAnswer(target: string, from: string, room: string, answer: RTCSessionDescriptionInit) {
    this.socket.emit('webrtc-answer', { to: target, from, room, answer });
  }

  sendIceCandidate(target: string, from: string, room: string, candidate: RTCIceCandidate) {
    this.socket.emit('ice-candidate', { to: target, from, room, candidate });
  }

  // Listeners
  onScreenShareRequest(): Observable<{ from: string, room: string, message: string }> {
    return new Observable(observer => {
      this.socket.on('screen-share-request', (data) => observer.next(data));
    });
  }

  onOffer(): Observable<{ offer: RTCSessionDescriptionInit, sender: string, room: string }> {
    return new Observable(observer => {
      this.socket.on('webrtc-offer', (data) => observer.next({
        offer: data.offer,
        sender: data.from,
        room: data.room
      }));
    });
  }

  onAnswer(): Observable<{ answer: RTCSessionDescriptionInit, sender: string, room: string }> {
    return new Observable(observer => {
      this.socket.on('webrtc-answer', (data) => observer.next({
        answer: data.answer,
        sender: data.from,
        room: data.room
      }));
    });
  }

  onIceCandidate(): Observable<{ candidate: RTCIceCandidate, sender: string, room: string }> {
    return new Observable(observer => {
      this.socket.on('ice-candidate', (data) => observer.next({
        candidate: data.candidate,
        sender: data.from,
        room: data.room
      }));
    });
  }

  onWebRTCEerror(): Observable<{ message: string, error: string }> {
    return new Observable(observer => {
      this.socket.on('webrtc-error', (data) => observer.next(data));
    });
  }
}
